import { render } from "./Myform.vue?vue&type=template&id=36c28243"
import script from "./Myform.vue?vue&type=script&lang=js"
export * from "./Myform.vue?vue&type=script&lang=js"

import "./Myform.vue?vue&type=style&index=0&id=36c28243&lang=css"

import exportComponent from "G:\\MET-CS601-Term-Project\\cs601-term-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__